import useFetch from 'utils/hooks/useFetch'
import { ApiGetDepositList, ApiInsertDepositReturn } from 'utils/constants/api'
import { CheckResponse } from 'utils/helpers'
import { useModal } from 'utils/context/ModalContext'

export function DepositReturnService() {
    const { showFail } = useModal()

    const { fetch: apiGetDepositList } = useFetch(ApiGetDepositList)
    const { fetch: apiCreateDeposit } = useFetch(ApiInsertDepositReturn)
 
    const fetchDepositList = async (tenantName, depositStatus, paymentType, status, pageSize, pageIndex) => {
        const res = await apiGetDepositList({
            data: {
                tenantName,
                depositStatus,
                paymentType,
                status,
                pageSize,
                pageIndex
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }
    const fetchCreateDeposit = async (paymentId, amount, depositStatus) => {
        const res = await apiCreateDeposit({
            data: {
                paymentId,
                depositStatus,
                amount
            }
        })

        if (!CheckResponse(res)) {
            showFail(res.message)
            return null
        }

        return res
    }

    return {
        fetchDepositList,
        fetchCreateDeposit
    }
}